import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './error/page-not-found/page-not-found.component';
import { HybridAuthValidGuard } from './auth/guards/hybrid-auth-valid.guard';
import { RedirectRDComponent } from './redirect-rd-component';
import { InternalUserGuard } from './auth/guards/internal-user.guard';
import { AuthValidGuard } from './auth/guards/auth-valid.guard';

const routes: Routes = [
    {
        path: 'events',
        loadChildren: () =>
            import('./events/events.module').then(m => m.EventsModule),
        canActivate: [AuthValidGuard, InternalUserGuard]
    },
    {
        path: 'upload',
        loadChildren: () =>
            import('./upload/upload.module').then(m => m.EventUploadModule),
        canActivate: [AuthValidGuard, InternalUserGuard]
    },
    {
        path: 'qc-hybrid',
        loadChildren: () =>
            import('./hybrid/hybrid.module').then(m => m.HybridModule),
        canActivate: [HybridAuthValidGuard]
    },
    {
        path: 'redirect-rd',
        component: RedirectRDComponent,
        canActivate: [AuthValidGuard]
    },
    {
        path: '',
        redirectTo: 'events',
        pathMatch: 'full'
    },
    { path: '**', component: PageNotFoundComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    declarations: []
})
export class AppRoutingModule {}
